import {Presential} from './Presential.model';
import {Language} from '../../shared/models/Language.model';
import {ScheduleAction} from './ScheduleAction';
import {User} from '../../shared/models/User';
import { CourseInstanceLocation } from './PresentialInstanceLocation';

export class PresentialInstance {
    public authorNote: string;
    public billable: boolean;
    public closed: boolean;
    public contextSkills: any;
    public course: string | Presential;
    public courseInstanceType: 'presential' | 'online';
    public createdBy: User;
    public currency: string;
    public dateDeleted: string;
    public id: string;
    public instructors: User[];
    public iri: string;
    public language: string | Language;
    public location: CourseInstanceLocation;
    public presentialContent: any;
    public price: number;
    public registrations: any;
    public remainingAttendeeCapacity: number;
    public remainingPlaces: number;
    public scheduleActions: ScheduleAction[];

    constructor(json?) {
        if (json != null) {
            this.iri = json['@id'];
            this.id = json.id;
            this.createdBy = json.createdBy;
            this.course = json.course;
            this.instructors = json.instructors;
            this.language = json.language;
            this.price = json.price;
            this.scheduleActions = json.scheduleActions;
            this.authorNote = json.authorNote;
            this.remainingPlaces = json.remainingPlaces;
            this.remainingAttendeeCapacity = json.remainingAttendeeCapacity;
            this.presentialContent = json.presentialContent;
            this.currency = json.currency;
            this.registrations = json.registrations;
            this.location = json.location;
            this.closed = json.closed;
            this.contextSkills = json.contextSkills;
            this.dateDeleted = json.dateDeleted;
            this.billable = json.billable;
            this.courseInstanceType = json.courseInstanceType;
        }
    }
}
